export const screenModule = {
    namespaced: true,
    state: {
        window: {
            height: 0,
            width: 0
        },
    },
    mutations: {
        setWindow(state){
            if (window){
                state.window = {
                    width: window.innerWidth,
                    height: window.innerHeight
                }
            }
        },
    },
}
